import api from "./api.service";

export interface Expediente {
  id: number;
  nro_expediente: string;
  tipo_expediente: string;
  estado: string;
  organo_jurisdiccional: string;
  demandante: string;
  demandados: string;
  partes_procesales: string;
  fecha_ingreso: string;
  distrito_judicial: string;
  materia: string;
  observaciones: string | null;
  telefono?: string | null;
  dni?: string | null;
  monto?: number | null;
  color?: string | null;
}

export const getExpedientesPorMes = async (
  anio: number,
  mes: number,
  tipoEstado: string,
  distrito: string = "18"
) => {
  try {
    const resp = await api.get("/expedientes/listado-por-mes-anio-materia", {
      params: { anio, mes, tipoEstado, distrito },
    });
    return resp.data;
  } catch (error) {
    console.error("Error obteniendo expedientes:", error);
    return { total: 0, data: [] };
  }
};

export const getExpedientesLaudos = async (
  anio: number,
  mes: number,
  distrito: string = "18"
) => {
  try {
    const resp = await api.get("/expedientes/listado-por-mes-anio-materia/laudo", {
      params: { anio, mes, tipoEstado: "CO", distrito },
    });
    return resp.data;
  } catch (error) {
    console.error("Error obteniendo expedientes de laudos:", error);
    return { total: 0, data: [] };
  }
};

export const getExpedientePorId = async (id: number) => {
  const resp = await api.get(`/expedientes/${id}`);
  return resp.data;
};

export const crearExpediente = async (expediente: Partial<Expediente>) => {
  const resp = await api.post("/expedientes", expediente);
  return resp.data;
};

export const actualizarExpediente = async (id: number, expediente: Partial<Expediente>) => {
  const resp = await api.put(`/expedientes/${id}`, expediente);
  return resp.data;
};

export const eliminarExpediente = async (id: number) => {
  const resp = await api.delete(`/expedientes/${id}`);
  return resp.data;
};

export const actualizarColorExpediente = (id: number, color: number) =>
  api.put(`/expedientes/${id}/color`, { color });

export const actualizarExpediente2 = (id: number, data: any) =>
  api.put(`/expedientes/actualizar/${id}`, data);

export const getExpedientesIncauta = async (
  anio: number,
  mes: number,
  distrito: string = "18"
) => {
  try {
    const resp = await api.get("/expedientes/listado-por-mes-anio-materia/incauta", {
      params: { anio, mes, tipoEstado: "CO", distrito },
    });
    return resp.data;
  } catch (error) {
    console.error("Error obteniendo expedientes de incautación:", error);
    return { total: 0, data: [] };
  }
};
